module.exports = __webpack_public_path__ + "static/media/wave.a0b6a0ee.png";